import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    servico: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3vr6mbjbvf464v0123g', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          servico: '',
          mensagem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '5551995670049';
    const message = encodeURIComponent('Olá! Gostaria de solicitar um orçamento para serviços condominiais.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Telefone',
      info: '(51) 99567-0049',
      subInfo: 'Seg a Sex: 8h às 18h',
      onClick: () => window.open('tel:+5551995670049', '_self')
    },
    {
      icon: 'ri-mail-line',
      title: 'E-mail',
      info: 'primecondominialsolucoes@gmail.com',
      subInfo: 'Resposta em até 2h',
      onClick: () => window.open('mailto:primecondominialsolucoes@gmail.com', '_self')
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Endereço',
      info: 'Rua Tiradentes, 764',
      subInfo: 'Canoas - RS',
      onClick: () => window.open('https://maps.google.com/?q=Rua+Tiradentes,+764,+Canoas,+RS', '_blank')
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'WhatsApp',
      info: '(51) 99567-0049',
      subInfo: 'Atendimento rápido',
      onClick: handleWhatsAppClick
    }
  ];

  return (
    <section id="contato" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Entre em Contato
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estamos prontos para atender suas necessidades. Entre em contato conosco e 
            solicite um orçamento personalizado para seu condomínio.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Fale Conosco
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {contactInfo.map((contact, index) => (
                <div 
                  key={index} 
                  onClick={contact.onClick}
                  className="bg-white p-6 rounded-2xl shadow-lg cursor-pointer hover:shadow-xl transition-shadow"
                >
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                    <i className={`${contact.icon} text-xl text-orange-600`}></i>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">
                    {contact.title}
                  </h4>
                  <p className="text-gray-700 font-medium">
                    {contact.info}
                  </p>
                  <p className="text-gray-500 text-sm">
                    {contact.subInfo}
                  </p>
                </div>
              ))}
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <h4 className="text-2xl font-bold text-gray-900 mb-4">
                Por que escolher a PRIME SOLUÇÕES?
              </h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-check-double-line text-orange-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h5 className="font-semibold text-gray-900">Resposta Rápida</h5>
                    <p className="text-gray-600">Atendimento em até 2 horas</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-double-line text-orange-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h5 className="font-semibold text-gray-900">Orçamento Gratuito</h5>
                    <p className="text-gray-600">Avaliação sem compromisso</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-double-line text-orange-600 text-xl mr-3 mt-1"></i>
                  <div>
                    <h5 className="font-semibold text-gray-900">Garantia de Qualidade</h5>
                    <p className="text-gray-600">Todos os serviços com garantia</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">
              Solicite um Orçamento
            </h3>
            
            <form onSubmit={handleSubmit} data-readdy-form id="contato-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="Seu nome completo"
                  />
                </div>
                <div>
                  <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">
                    Telefone *
                  </label>
                  <input
                    type="tel"
                    id="telefone"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder="(11) 99999-9999"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="seu@email.com"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="servico" className="block text-sm font-medium text-gray-700 mb-2">
                  Serviço de Interesse
                </label>
                <div className="relative">
                  <select
                    id="servico"
                    name="servico"
                    value={formData.servico}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm appearance-none bg-white"
                  >
                    <option value="">Selecione um serviço</option>
                    <option value="manutencao">Manutenção Predial</option>
                    <option value="jardinagem">Jardinagem e Paisagismo</option>
                    <option value="seguranca">Segurança e Portaria</option>
                    <option value="limpeza">Limpeza Especializada</option>
                    <option value="administracao">Administração Predial</option>
                    <option value="reformas">Reformas e Melhorias</option>
                    <option value="outros">Outros</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2">
                  Mensagem
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                  placeholder="Descreva suas necessidades ou dúvidas..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">
                  Máximo 500 caracteres ({formData.mensagem.length}/500)
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting || formData.mensagem.length > 500}
                className="w-full bg-orange-600 text-white py-4 rounded-lg font-semibold hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Solicitação'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  <i className="ri-check-line mr-2"></i>
                  Mensagem enviada com sucesso! Entraremos em contato em breve.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  <i className="ri-error-warning-line mr-2"></i>
                  Erro ao enviar mensagem. Tente novamente ou entre em contato por telefone.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
